import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"
import { useParams } from "react-router"
import { navigateSchedulePreview } from "../../utilities/project-navigation"
import { isLockedToLegacy } from "authoring/lib/enum/project-phase.mjs"

export function PreviewSchedule() {
    const { projectId } = useParams()
    const { targetId: scheduleId, target: project } = useBoundContext()

    const isDisabled = isLockedToLegacy(project.phase)

    return (
        <ContextMenuItem
            icon="carbon:view-filled"
            label="Preview"
            onClick={() => navigateSchedulePreview({ projectId, scheduleId })}
            disabled={isDisabled}
        />
    )
}
